import angular from 'angular';
import { isString, startCase } from 'lodash';

module.exports = angular.module('common.filters.firstName', [])
.filter('firstName', function() {
  return function(input) {
    if (!isString(input)) return input;
    let parts = input.trim().split(' ');
    return startCase(parts[0]);
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/first-name.js
 **/